<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h15">DEDICATION</h1>
<p class="p12"> </p>
<p class="p13">Born of blood and violence and the mind of S.A. McAuley. </p>
<p class="p13">Love ya, Boo!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006.vue?13e54168